module.exports = __webpack_public_path__ + "img/17.e6eaab17.jpg";